const BASE_URL = "https://ignosi.in/websiteapi"; // Live Server
// const BASE_URL = "http://localhost/aignosiwebsitesir"; // Local XAMPP Server

export default BASE_URL;
